import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SongItemWrapper from '../SongItemWrapper/SongItemWrapper';
import SongItem from '../SongItem/SongItem';
import PopUp from '../../../../Shared/Popup/PopUp';
import { setShowDownloadSongPopUp, reportAnalytics } from '../../fundialSlice';


const DownloadSongPopUp = (props) => {

      function closePopup(){
        props.reportAnalytics({
            eventCategory: 'fundial',
            eventAction: "HN_PopUp_Exit",
            eventLabel: "",
          });
        props.setShowDownloadSongPopUp(false);
      }

    return (<>
        {props.audio ?
            <PopUp className="fundial-download-song-popup" showPopUp={props.showDownloadSongPopUp} onClose={() => { closePopup() }}>
                <SongItemWrapper audio={props.audio} isDownloadMode={true} isPlaylistMode={false} songId={props.audio.id}  >
                    <SongItem isDisplayPlayer={true} playerSize={87} isDetailsFromLeft={true} audio={props.audio} onClickSong={() => {}}  ></SongItem>
                </SongItemWrapper>
            </PopUp>
            : null
        }
        </>
    )
};

const mapStateToProps = (state) => {
    return {
        audio: state.fundialPage.selectedSong,
        showDownloadSongPopUp : state.fundialPage.showDownloadSongPopUp
    };
};

const mapDispatchToProps = {
    setShowDownloadSongPopUp,
    reportAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadSongPopUp);